import { NoopTelemetry, type TelemetryPort } from "@stormglass/game-telemetry";

export interface AppTelemetryAdapters {
  readonly analytics: TelemetryPort;
  readonly crashes: TelemetryPort;
}

declare global {
  var __STORMGLASS_TELEMETRY__: AppTelemetryAdapters | undefined;
}

/** Provider clients can be injected by the deployment entrypoint without coupling the game host to an SDK. */
export const createAppTelemetry = (): AppTelemetryAdapters =>
  globalThis.__STORMGLASS_TELEMETRY__ ?? {
    analytics: new NoopTelemetry(),
    crashes: new NoopTelemetry(),
  };
